(() => {
  const roots = '[data-collection-finish-root]';
  const productsHash = '#collection-products';
  function scrollToProducts(root) {
    window.CollectionFilters?.scrollToProducts(root);
  }

  function restorePaginationPosition() {
    if (window.location.hash !== productsHash) return;
    const root = document.querySelector(roots + '[data-finish-mode="essentials"]');
    if (root) scrollToProducts(root);
  }

  const contextToolbars = new WeakMap();

  function setupContextToolbar(root) {
    if (contextToolbars.has(root)) return;
    const toolbar = root.querySelector('[data-collection-context-toolbar]');
    const titles = toolbar && [...toolbar.querySelectorAll('[data-collection-title]')];
    const markers = [...root.querySelectorAll('[data-collection-title-marker]')];
    if (!titles?.length || !markers.length) return;

    let observer;
    let frame;
    let boundary = 0;
    let geometry = '';
    const update = () => {
      const visibleMarkers = markers.filter(marker => !marker.closest('[hidden]'));
      if (!visibleMarkers.length) return;
      let current = visibleMarkers[0].dataset.collectionTitleMarker;
      for (const marker of visibleMarkers) {
        if (marker.getBoundingClientRect().top <= boundary + 1) {
          current = marker.dataset.collectionTitleMarker;
        }
      }
      for (const title of titles) {
        const active = title.dataset.collectionTitle === current;
        title.classList.toggle('is-active', active);
        title.setAttribute('aria-hidden', String(!active));
      }
      toolbar.dataset.activeSection = current;
    };
    const refresh = () => {
      const top = parseFloat(getComputedStyle(toolbar).top) || 0;
      const gap = parseFloat(getComputedStyle(root).getPropertyValue('--space-md')) || 16;
      boundary = Math.min(window.innerHeight - 1, Math.ceil(top + toolbar.getBoundingClientRect().height + gap) + 2);
      const nextGeometry = `${boundary}:${window.innerHeight}`;
      if (geometry !== nextGeometry) {
        geometry = nextGeometry;
        observer?.disconnect();
        observer = new IntersectionObserver(update, {
          rootMargin: `-${boundary}px 0px 0px 0px`,
          threshold: 0
        });
        markers.forEach(marker => observer.observe(marker));
      }
      update();
    };
    const schedule = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(refresh);
    };
    const resize = new ResizeObserver(schedule);
    [toolbar, document.querySelector('.Header'), document.querySelector('.AnnouncementBar')]
      .filter(Boolean).forEach(element => resize.observe(element));
    const onResults = event => {
      if (event.detail?.root === root) schedule();
    };
    window.addEventListener('resize', schedule, { passive: true });
    document.addEventListener('collection-finish:updated', onResults);
    contextToolbars.set(root, () => {
      cancelAnimationFrame(frame);
      observer?.disconnect();
      resize.disconnect();
      window.removeEventListener('resize', schedule);
      document.removeEventListener('collection-finish:updated', onResults);
      contextToolbars.delete(root);
    });
    refresh();
  }

  function setupContextToolbars(scope = document) {
    if (scope.matches?.(roots)) setupContextToolbar(scope);
    scope.querySelectorAll(roots).forEach(setupContextToolbar);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setupContextToolbars(), { once: true });
  } else setupContextToolbars();
  document.addEventListener('shopify:section:load', event => setupContextToolbars(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll(roots).forEach(root => contextToolbars.get(root)?.());
  });

  document.addEventListener('click', event => {
    const root = event.target.closest(roots);
    if (!root) return;
    const pops = root.dataset.finishMode === 'pops';
      if (pops) {
        const anchor = event.target.closest('.PopsCollection__stepLink, .PopsCollection__actions a[href^="#"]');
        const toolbar = root.querySelector('[data-collection-filter-toolbar]');
        const target = anchor && root.querySelector(anchor.getAttribute('href'));
        if (target && toolbar) {
          const toolbarStyle = getComputedStyle(toolbar);
          const toolbarOffset = toolbar.getBoundingClientRect().height;
          const gap = parseFloat(getComputedStyle(root).getPropertyValue('--space-md')) || 16;
          const targetPadding = target.matches('.PopsCollection__group')
            ? parseFloat(getComputedStyle(target).paddingTop) || 0
            : 0;
          const announcementHeight = document.querySelector('.AnnouncementBar')?.clientHeight || 0;
          // The theme scroll handler subtracts the announcement bar from this offset.
          anchor.dataset.offset = String(Math.ceil(
            (parseFloat(toolbarStyle.top) || 0) + toolbarOffset
            + gap - targetPadding + announcementHeight
          ));
        }
      }
  }, true);
  if (document.readyState === 'complete') requestAnimationFrame(restorePaginationPosition);
  else window.addEventListener('load', () => requestAnimationFrame(restorePaginationPosition), { once: true });
})();
